import ButtonAppBar from "../../components/Navbar/index.js";
import UserEstimation from "../../components/EstimationForm/index.js";
import "./index.css";
import BrokerDataTable from "../../components/BrokersData/DisplayBrokers/index.js";
import BlockCard from "../../components/Blocks/BlockCard/index.js";
import TaxesData from "../../components/BrokersData/DisplayTaxes/inedx.js";

import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import NewsDisplay from "../../components/News/NewsDisplay/index.js";
import Footer from "../../components/Footer";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Discover() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="Navbar">
        <ButtonAppBar />
      </div>

      <div className="DiscoverBody">
        <Box className="Bar" sx={{ width: "100%" }}>
          <Box
            sx={{ borderBottom: 1, borderColor: "divider" }}
            style={{ width: "95%", margin: "auto" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Discover" {...a11yProps(0)} />
              <Tab label="News" {...a11yProps(1)} />
              <Tab label="More" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <div className="BlockCards">
              <BlockCard />
            </div>
            <div className="EstimationForm">
              <UserEstimation />
            </div>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <NewsDisplay />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <div className="Taxes">
              <TaxesData />
            </div>
            <div className="BrokerTable">
              <BrokerDataTable />
            </div>
          </TabPanel>
        </Box>
      </div>
      <Footer />
    </>
  );
}
